// extracted by mini-css-extract-plugin
export default {"patient":"DischargeConfirmationModal_patient__wOmBx"};